{
  "de": {
    "apps": {
      "ai_assistant": {
        "color": "var(--brand-7)",
        "description": "Entdecke hilfreiche Chatbots für dich und deine Schüler*innen.",
        "descriptionPupils": "Entdecke hilfreiche Chatbots für dich und deine Schüler*innen.",
        "icon": "bi-grid-3x3",
        "longDescriptionHtml": "Mit diesem Tool können Schüler*innen historische oder fiktive Charaktere kennenzulernen und mit ihnen interagieren. Die Schüler können in Rollenspielen, Schreibprojekten, Präsentationen und anderen kreativen Aktivitäten mit diesen Charakteren interagieren und sie besser verstehen.",
        "name": "KI-Assistenten Katalog",
        "useCasesHtml": "<ul> <li>Kreatives Schreiben: Schüler können Aufsätze oder Kurzgeschichten schreiben, in denen sie in Dialoge mit historischen oder fiktiven Charakteren treten und ihre Gedanken und Gefühle teilen.</li> <li>Vorträge und Präsentationen: Schüler können über historische oder fiktive Charaktere recherchieren und Präsentationen halten, um ihr Wissen und Verständnis zu demonstrieren und ihre Persönlichkeiten zu diskutieren.</li> <li>Quiz- und Trivia-Spiele: Schüler können Quiz- oder Trivia-Spiele spielen, in denen sie Fragen über historische oder fiktive Charaktere beantworten, um ihr Wissen zu testen und zu vertiefen.</li> </ul>"
      },
      "ai_audio": {
        "description": "Lass Tonspuren aus verschiedenen Quellen für dich einsprechen.",
        "icon": "bi-soundwave",
        "name": "Text vorlesen lassen"
      },
      "ai_chat": {
        "customBadgeLabel": "mit Assistenten",
        "description": "Nutze die textgenerierende KI für Unterstützung bei vielen Aufgaben.",
        "descriptionPupils": "Probiere aus, bei welchen Aufgaben dir die KI beim Lernen helfen kann.",
        "longDescriptionHtml": "Lass unsere KI-Assistenz dir dabei helfen, deinen Unterricht zu gestalten und deine Arbeit zu organisieren.",
        "name": "KI Chat",
        "useCasesHtml": "<ul> <li>Lasse dir Elternbriefe in <strong>verschiedene Sprachen</strong> übersetzen.</li> <li>Lasse dir Vorschläge für <strong>Aufgaben und Musterlösungen</strong> anlegen.</li> <li>Lasse dir <strong>Materiallisten</strong> für Experimente anlegen.</li> <li>Lasse komplexe Texte kurz und <strong>altersstufengerecht zusammenfassen</strong>.</li> <li>Lasse dir den <strong>Ablauf des Elternabends</strong> planen.</li> <li>Lasse dir die <strong>wichtigsten Informationen</strong> zu einem Thema heraussuchen.</li> <li>Lasse dir <strong>Code-Schnipsel</strong> erzeugen oder überarbeiten.</li> </ul>",
        "videos": [
          {
            "id": "1055561400"
          }
        ]
      },
      "ai_converter": {
        "description": "Erstelle Podcasts, Impulsvorträge, Tonspuren und Transkripte aus verschiedenen Quellen",
        "longDescriptionHtml": "Die KI Multimedia Tools bieten dir neue Möglichkeiten Inhalte für deinen Unterricht zu gestalten und umzuwandeln.",
        "name": "KI Multimedia Tool",
        "useCasesHtml": "<ul><li>Verwandle Inhalte in einen <strong>Podcast oder Impulsvortrag</strong> zum Thema deiner Wahl - mit Tonspur und Transkript</li><li>Erstelle <strong>Hörverstehensaufgaben</strong> für deinen Unterricht und lass Tonspuren aus verschiedenen Quellen für dich einsprechen.</li><li><strong>Verwandle Sprachnachrichten und Videos in Text</strong> und verwende das Transkript für weitere Aufgaben.</li><li>Erhalte einen Fließtext aus Fotos und Text von <strong>Handschriften</strong>.</li></ul>",
        "videos": [
          {
            "id": "1035178374"
          }
        ]
      },
      "ai_dialog": {
        "description": "Lass Dialoge als Podcasts mit zwei Sprechern einsprechen.",
        "icon": "bi-chat-quote",
        "name": "Dialog vorlesen lassen"
      },
      "ai_document_qa": {
        "description": "Stelle Fragen zu Dokumenten und lasse Inhalte mit KI einfach zusammenfassen.",
        "descriptionPupils": "Stelle Fragen zu Inhalten von PDFs und lass dir Inhalte einfach aufbereiten.",
        "longDescriptionHtml": "Durchsuche bestimmte Dokumente nach Informationen und lasse sie dir gezielt aufbereiten.",
        "name": "PDF Chat",
        "useCasesHtml": "<ul> <li>Stelle Fragen zu den gesamten Inhalten eines PDF.</li> <li>Lasse dir die wichtigsten Punkte einer Quelle in beliebiger Länge zusammenfassen.</li> <li>Durchsuche Dokumente nach Inhalten und lasse sie dir in der gewünschten Form aufbereiten.</li> <li>Erhalte eine fertige Gliederung zu den Inhalten in einer PDF.</li> <li>Lasse dir fertige Frage-Antwort Paare für Tests und Lernstandskontrollen auf Basis einer bestimmten Quelle anlegen.</li> </ul>",
        "videos": [
          {
            "id": "861302260"
          }
        ]
      },
      "ai_feedback": {
        "description": "Erhalte KI-generierte Bewertungs­­vorschläge auf Basis deiner Kriterien.",
        "longDescriptionHtml": "Spare wertvolle Zeit beim Korrigieren durch KI-gestützte Fehlerkorrektur und Bewertungsvorschläge.",
        "name": "Korrekturhilfe",
        "useCasesHtml": "<ul> <li>Erhalte KI-generierte Fehlerlisten und Vorkorrekturen für Schüler'*innentexte.</li> <li>Lege eigene Bewertungskriterien fest und erhalte individuelles Feedback und Verbesserungsvorschläge.</li></ul>",
        "videos": [
          {
            "id": "927570307"
          }
        ]
      },
      "ai_feedback_result": {
        "name": "Korrekturhilfe Ergebnisse"
      },
      "ai_image": {
        "description": "Erstelle Bilder aus Textbeschreibungen mit Hilfe von bildgenerierender KI.",
        "descriptionPupils": "Experimentiere mit Beschreibungen und Stilen und verwandle sie in kreative Bilder.",
        "longDescriptionHtml": "Lass dir einen Gedanken in ein <strong>Bild verwandeln</strong> und veranschauliche Konzepte und Ideen im Unterricht.",
        "name": "Bild generieren",
        "useCasesHtml": "<ul> <li>Erstelle lizenzfreie Bilder zur <strong>Illustration von Unterrichtsmaterialien</strong>.</li> <li>Erhalte <strong>mehrere Versionen von Bildern</strong> und Motiven in verschiedenen Stilrichtungen.</li> <li>Diskutiere mit Schüler*innen Assoziationen, Stilrichtungen und <strong>kreative Möglichkeiten</strong>.</li> </ul>",
        "videos": [
          {
            "id": "857074332"
          }
        ]
      },
      "ai_lecture": {
        "description": "Erhalte einen kurzen Vortrag zum Thema deiner Wahl - mit Tonspur und Transkript.",
        "icon": "bi-book",
        "name": "Impulsvortrag erstellen"
      },
      "ai_message": {
        "name": "KI Prompts"
      },
      "ai_mini_tool": {
        "customBadgeLabel": "55+ Tools",
        "description": "Nutze fertige Prompts, um vielseitige Aufgaben schnell für dich zu erledigen.",
        "icon": "bi-lightbulb",
        "longDescriptionHtml": "Über 55 fertige Promptbeispiele nehmen dir wiederkehrende Aufgaben aus dem Schulalltag ab – von der Unterrichtsplanung bis zur Elternkommunikation, ganz ohne selbst Prompts schreiben zu müssen.",
        "name": "Promptlabor",
        "useCasesHtml": "<ul> <li>Plane <strong>Unterrichtsreihen und einzelne Stunden</strong> passend zu Fach, Klassenstufe und Thema.</li> <li>Erstelle <strong>Materialien und Aufgaben</strong> mit wenigen Angaben in Sekunden.</li> <li>Finde <strong>Differenzierungsideen</strong>, um Aufgaben an unterschiedliche Niveaus anzupassen.</li> <li>Formuliere <strong>Feedback und Beurteilungen</strong> mit passenden Formulierungshilfen.</li> <li>Bereite <strong>Elterngespräche und E-Mails</strong> klar und im richtigen Ton vor.</li> <li>Hol dir <strong>kreative Projekt- und Unterrichtsideen</strong> für neuen Input.</li> </ul>",
        "videos": [
          {
            "id": "1201506097"
          }
        ]
      },
      "ai_mini_tool_request": {
        "name": "Promptlabor Anfragen"
      },
      "ai_my_assistants": {
        "description": "Erstelle eigene Chatbots mit \"Hintergrundwissen\" und genauen Instruktionen.",
        "icon": "bi-stars",
        "name": "Eigene KI-Assistenten"
      },
      "ai_persona": {
        "description": "Unterhalte dich mit Chatbots verschiedener Charaktere und Figuren.",
        "descriptionPupils": "Chatte mit spannenden und berühmten Menschen oder mit lustigen Figuren.",
        "longDescriptionHtml": "Lass die KI in andere Rollen schlüpfen, die du über ihr Wissen und ihre Erfahrungen ausfragen kannst.",
        "name": "KI Rollenspiel",
        "useCasesHtml": "<ul> <li>Unterhalte dich mit <strong>historischen Persönlichkeiten</strong> über das Zeitgeschehen in der Vergangenheit.</li> <li><strong>Lerne von Expert*innen</strong> in einem bestimmten Gebiet und frage sie über ihre Erfahrungen aus.</li> <li>Führe ein <strong>Interview mit Schriftsteller*innen</strong> über die Entstehungsgeschichte und Hintergründe ihrer Werke.</li> <li>Teste mit <strong>lustigen Figuren</strong> die Möglichkeiten und Grenzen von Künstlicher Intelligenz aus.</li> <li>Wähle deine Lieblingsperson oder -figur als Lerncoach und frage sie nach <strong>Tipps für deinen Lernprozess</strong> oder eine konkrete Aufgabe.</li> </ul>"
      },
      "ai_podcast": {
        "description": "Verwandle Inhalte in ein Gespräch zum Anhören - mit Tonspur und Transkript.",
        "icon": "bi-mic",
        "name": "Podcast erstellen"
      },
      "ai_summary": {
        "description": "Erstelle eine Zusammenfassung aus einem Text, einer Website oder anderen Quellen.",
        "icon": "bi-journal-text",
        "name": "Zusammenfassung erstellen"
      },
      "ai_text": {
        "description": "Wandle Texte aus Bildern oder Dokumenten in Fließtext um.",
        "icon": "bi-file-earmark-font",
        "name": "Text aus Bild oder Datei erkennen"
      },
      "ai_transcript": {
        "description": "Wandle den Text von Tonspuren oder YouTube Videos in Transkripte um.",
        "icon": "bi-vector-pen",
        "name": "Transkript erstellen"
      },
      "ai_translation": {
        "description": "Erstelle eine Übersetzung aus einem Text, einer Website oder anderen Quellen.",
        "icon": "bi-translate",
        "name": "Text übersetzen"
      },
      "audio_recorder": {
        "description": "Erstelle Audio-Aufnahmen und teile sie digital und sicher mit Schüler*innen.",
        "icon": "bi-file-music",
        "longDescriptionHtml": "Erstelle Audio-Aufnahmen und teile diese dann mit einem Link oder QR-Code.",
        "name": "Audio-Aufnahme",
        "useCasesHtml": "<ul> <li>Gib <strong>Audio-Feedback</strong> zu Hausaufgaben, Projektarbeiten und Klassenarbeiten</li> <li>Teile versteckte Hinweise per Audio-Nachricht bei einem EduBreakout</li> <li>Stelle zusätzliche <strong>auditive Hilfestellungen</strong> zur Verfügung, z. B. für Schüler*innen mit Leseschwäche</li> <li>Schicke Grußbotschaften und Sprachnachrichten an Schüler*innen</li> </ul>",
        "videos": [
          {
            "id": "1081427797"
          }
        ]
      },
      "classroom_screen": {
        "description": "Erstelle multimediale Tafelbilder, binde Inhalte ein und teile sie digital.",
        "longDescriptionHtml": "Erstelle multimediale Tafelbilder und strukturiere deine Unterrichtsinhalte. Gestalte deinen Unterricht live und digital.",
        "name": "Digitale Tafel",
        "useCasesHtml": "<ul> <li>Visualisiere Unterrichtsinhalte und reichere sie <strong>mit multimedialen Inhalten</strong> an</li> <li>Notiere und gliedere Inhalte und Elemente an einem <strong>dynamischen Tafelbild</strong></li> <li><strong>Sammle Ideen gemeinsam</strong> mit deinen Schüler*innen</li> <li>Erkläre und teile Arbeitsaufträge übersichtlich an der digitalen Tafel</li> <li>Eine digitale Uhr, Timer und Symbole für Arbeitsphasen helfen dir beim <strong>Strukturieren deines Unterrichts</strong></li> </ul>",
        "videos": [
          {
            "id": "1099598765"
          }
        ]
      },
      "file_sharing": {
        "description": "Lade Dateien hoch und teile sie digital und sicher mit Schüler*innen.",
        "longDescriptionHtml": "Lade beliebige Dateien hoch und teile diese anschließend mit einem Link oder QR-Code.",
        "name": "Datei teilen",
        "useCasesHtml": "<ul> <li>Teile Arbeitsblätter und Hausaufgaben <strong>einfach und datenschutzsicher</strong> mit Schüler*innen</li> <li>Verteile <strong>Unterrichtsmaterialien</strong> und <strong>Arbeitsaufträge</strong> in Tablet-Klassen</li> <li>Erteile temporäre Zugriffsrechte für bestimmte Lerngruppen</li> <li>Tausche Unterrichtsentwürfe und -materialien mit Kolleg*innen aus</li> </ul>",
        "videos": [
          {
            "id": "1099346864"
          }
        ]
      },
      "link_shortener": {
        "description": "Erstelle Kurzlinks für digitale Inhalte und teile sie digital und sicher mit Schüler*innen.",
        "longDescriptionHtml": "Kürze eine URL und teile diese anschließend mit einem Link oder QR-Code.",
        "name": "Link kürzen",
        "useCasesHtml": "<ul> <li>Teile Unterrichtsmaterialien, Videos oder digitale Inhalte mit <strong>sicheren Links</strong></li> <li>Erteile temporäre Zugriffsrechte für ausgewählte Lerngruppen</li> <li>Sichere deine Links <strong>mit geschützten Passwörtern</strong></li> </ul>",
        "videos": [
          {
            "id": "1080119234"
          }
        ]
      },
      "pinboard": {
        "defaults": {
          "boardName": "Eigene Pinnwand",
          "cardName": "Karte Nr.1",
          "listName": "Erste Liste"
        },
        "description": "Erstelle interaktive Pinnwände und bearbeite sie gemeinsam mit Schüler*innen.",
        "longDescriptionHtml": "Arbeite gemeinsam mit anderen an einem interaktiven Board. Nutze Karten, um Inhalte strukturiert zu teilen.",
        "name": "Pinnwand",
        "useCasesHtml": "<ul> <li>Erstelle <strong>digitale Wochenpläne</strong> mit Arbeitsaufträgen und Unterrichtsmaterialien</li> <li>Erstelle Zeitpläne für digitale, hybride oder Präsenz-Veranstaltungen</li> <li>Erstelle <strong>Lerntheken</strong> zu bestimmten Unterrichtseinheiten</li> <li>Sichere Vorwissen von Schüler*innen auf einem <strong>interaktiven Board</strong></li> <li>Dokumentiere Unterrichtsinhalte und Ergebnisse gemeinsam mit Schüler*innen</li> </ul>",
        "videos": [
          {
            "id": "1098739712"
          }
        ]
      },
      "project": {
        "name": "Projekte im Klassenraum"
      },
      "pupil_feedback": {
        "description": "Gib Schüler*innen Zugang zu individuellem KI-Feedback zu ihren Aufgaben.",
        "longDescriptionHtml": "Dieses Tool gibt Schüler*innen KI-generierte Rückmeldungen und differenzierte Verbesserungsvorschläge für Texte und Aufgaben.",
        "name": "Feedback für Schüler*innen",
        "useCasesHtml": "<ul> <li>Begleite Schreibaufgaben deiner Schüler*innen mit <strong>KI-basiertem Feedback</strong> in Echtzeit.</li> <li>Unterstütze Schüler*innen KI-basiert im selbständigen Lernprozess und <strong>werde selbst spürbar entlastet.</strong></li> <li>Steuere das KI-generierte Feedback durch <strong>individuell festgelegte Kriterien</strong>.</li> </ul>",
        "videos": [
          {
            "id": "1028586715"
          }
        ]
      },
      "qrcodes": {
        "description": "Generiere QR-Codes aus Links und binde sie in Unterrichtsmaterialien ein.",
        "longDescriptionHtml": "Erstelle einen QR-Code aus einer URL und teile ihn anschließend digital mit deinen Schüler*innen.",
        "name": "QR-Code anlegen",
        "useCasesHtml": "<ul> <li>Teile Unterrichtsmaterialien, Präsentationen oder digitale Ressourcen direkt über <strong>QR-Codes</strong></li> <li><strong>Erleichtere den Zugang</strong> zu Online-Umfragen oder Feedback-Formularen für deine Schüler*innen</li> <li>Binde QR-Codes in Arbeitsblätter oder Plakate ein, um <strong>zusätzliche Informationen</strong> bereitzustellen</li> </ul>"
      },
      "school_class": {
        "description": "Teile Arbeitsaufträge, Materialien und KI-Tools mit deinen Schüler*innen – in einer sicheren, datenschutzkonformen Lernumgebung.",
        "longDescriptionHtml": "Jede*r Schüler*in arbeitet im eigenen Bereich an deinen Projekten, ganz ohne eigenen fobizz-Account. Du entscheidest, welche Tools und Materialien freigeschaltet sind, und behältst alle Aktivitäten im Überblick.",
        "name": "Klassenraum",
        "newFeaturesHtml": "<strong>Neu:</strong> Lade andere Lehrkräfte zu deinen Projekten ein, filtere Aktivitäten gezielt, hänge eigene Dateien an und verknüpfe Klassenräume mit deiner Schule.",
        "useCasesHtml": "<ul> <li>Chancen und Risiken von KI gemeinsam testen und diskutieren.</li> <li>Die KI als Feedbackgeber beim Schreiben und Überarbeiten von Texten nutzen.</li> <li>Eigene Materialien und KI-Assistenten bereitstellen, z. B. eine „Sprachtrainerin“ für den Fremdsprachenunterricht.</li> <li>Mit historischen Sparringspartner*innen ins Gespräch kommen und neue Perspektiven einnehmen.</li> </ul>",
        "useCasesTitle": "So kannst du ihn einsetzen:",
        "videoIntroText": "Wie du einen Klassenraum Schritt für Schritt einrichtest, zeigt dir unser Video in rund 5 Minuten.",
        "videos": [
          {
            "id": "1085940985"
          }
        ]
      },
      "screen_recorder": {
        "description": "Erstelle Bildschirm-Aufnahmen und teile sie sicher.",
        "longDescriptionHtml": "Erstelle Bildschirm-Aufnahmen und teile diese dann mit einem Link oder QR-Code.",
        "name": "Bildschirm-Aufnahme",
        "useCasesHtml": "<ul> <li>Erstelle <strong>Erklärvideos</strong> und <strong>Arbeitsaufträge per Bilschirm-Video</strong></li> <li>Präsentiere in einer <strong>Bildschirm-Aufnahme</strong> die Nutzung von <strong>Webseiten</strong> oder <strong>Programmen</strong></li> <li>Gib <strong>Videofeedback</strong> zu digital eingereichten Hausaufgaben, Projektarbeiten und Klassenarbeiten</li> <li>Erarbeite in einem <strong>Bildschirm-Video</strong> eine <strong>Musterlösung</strong></li> </ul>",
        "videos": [
          {
            "id": "1080171837"
          }
        ]
      },
      "surveys": {
        "description": "Erstelle Umfragen, teile sie und die Ergebnisse und werte sie digital aus.",
        "icon": "bi-clipboard-data",
        "longDescriptionHtml": "Erstelle eine Umfrage zum Ausfüllen und wähle dabei aus verschiedenen Frage-/Aufgabentypen. Teile die Umfrage mit einem Link oder QR-Code und werte die Ergebnisse aus.",
        "name": "Umfrage",
        "useCasesHtml": "<ul> <li>Erstelle <strong>Umfragen, Formulare</strong> und <strong>Wissensabfragen</strong></li> <li>Frage (Vor-)Wissen, Meinungen und Selbsteinschätzungen von Schüler*innen ab</li> <li>Erstelle Quizze und Lernstandserhebungen, Übungen und Aufgabenstellungen</li> <li>Erfasse <strong>Unterrichtsfeedback</strong> digital und anonym und werte es online aus</li> <li>Sammle die Ergebnisse digital ein und werte sie einfach und übersichtlich aus</li> </ul>",
        "videos": [
          {
            "id": "1082076667"
          }
        ]
      },
      "to_teach_worksheet_import": {
        "description": "Importiere deine Inhalte direkt von to teach und nutze sie u.a. im fobizz Klassenraum.",
        "name": "Arbeitsblatt"
      },
      "text_editor": {
        "description": "Verfasse und bearbeite Textdokumente gemeinsam mit Schüler*innen - mit KI-Hilfe.",
        "descriptionPupils": "Verfasse und bearbeite Textdokumente gemeinsam.",
        "longDescriptionHtml": "Erstelle Textdokumente ohne technische Vorkenntnisse und teile diese dann mit einem Link oder QR-Code.",
        "name": "Texteditor",
        "useCasesHtml": "<ul> <li>Gruppenprojekte und Brainstorming: Schüler*innen können gemeinsam an Projekten arbeiten und Ideen oder Themen sammeln, die im Unterricht diskutiert werden sollen.</li> <li>Zusammenfassungen und Protokolle: Schüler*innen können gemeinsam Dokumente verfassen, Inhalte organisieren und strukturieren.</li> <li>Kreatives Schreiben und Schreibkonferenzen: Schüler*innen können eigene oder fremde Texte gemeinsam mit Mitschüler*innen verfassen, überarbeiten und verbessern.</li> <li>KI: Die integrierte Künstliche Intelligenz hilft beim Schreiben und Überarbeiten der Inhalte und unterstützt mit Rechtschreib- und Grammatiktipps sowie mit Übersetzungshilfe.</li> </ul>",
        "videos": [
          {
            "id": "1099598997"
          }
        ]
      },
      "video_recorder": {
        "description": "Erstelle Video-Aufnahmen und teile sie digital und sicher mit Schüler*innen.",
        "longDescriptionHtml": "Erstelle Video-Aufnahmen und teile diese dann mit einem Link oder QR-Code.",
        "name": "Video-Aufnahme",
        "useCasesHtml": "<ul> <li>Erstelle einfache <strong>Erklärvideos</strong> und <strong>Arbeitsaufträge per Video</strong></li> <li>Gib <strong>Videofeedback</strong> zu Hausaufgaben, Projektarbeiten und Klassenarbeiten</li> <li>Stelle Lernhilfen oder Aufgaben zur Binnendifferenzierung per <strong>Videonachricht</strong> zur Verfügung</li> </ul>",
        "videos": [
          {
            "id": "1081467617"
          }
        ]
      },
      "website": {
        "description": "Erstelle einfache digitale Webseiten, binde Inhalte ein und teile sie digital.",
        "icon": "bi-window",
        "longDescriptionHtml": "Erstelle eine Webseite ohne technische Vorkenntnisse und teile diese dann mit einem Link oder QR-Code.",
        "name": "Webseite",
        "useCasesHtml": "<ul> <li>Nutze die Webseite als <strong>digitales weißes Blatt Papier</strong>, das du mit freien Inhalten füllen kannst</li> <li>Erstelle <strong>Merkzettel, Elternbriefe oder Blogbeiträge</strong> und teile sie mit Eltern und Schüler*innen</li> <li>Teile eine <strong>Linksammlung</strong> zu einem bestimmten Thema</li> <li>Erstelle <strong>Lernpfade und Lerntheken</strong> mit multimedialen Inhalten</li> </ul>",
        "videos": [
          {
            "id": "1099599088"
          }
        ]
      },
      "word_clouds": {
        "description": "Erstelle Wortwolken mit Fragen und Blitzlichtern und teile sie digital. ",
        "longDescriptionHtml": "Erstelle Wortwolken aus einer Liste von Wörtern oder kollaborativ mit deinen Schüler*innen.",
        "name": "Wortwolke",
        "newlineSeparatedWordsPlaceholder": "Wenn\nFliegen\nhinter\nFliegen\nfliegen\nfliegen\nFliegen\nhinter\nFliegen\nher",
        "useCasesHtml": "<ul> <li>Erstelle Wortwolken als aktivierenden Unterrichtseinstieg </li> <li>Nutze Wortwolken <strong>zum kreativen Brainstorming</strong> mit Schüler*innen</li> <li>Frage Vorwissen oder Assoziationen der Schüler*innen ab</li> <li>Sammle <strong>Stimmungsbilder</strong> im Unterricht oder bei Elternabenden</li> </ul>",
        "videos": [
          {
            "id": "1098820202"
          }
        ]
      },
      "worksheet": {
        "consolidatedDescription": "Arbeitsblätter selbst erstellen, per KI generieren oder von to teach importieren.",
        "description": "Erstelle Arbeitsblätter mit eigenen Inhalten, teile und werte sie digital aus.",
        "longDescriptionHtml": "Erstelle ein Arbeitsblatt zum Ausfüllen und wähle dabei aus verschiedenen Frage-/Aufgabentypen. Teile dein Arbeitsblatt mit einem Link oder QR-Code und werte die Ergebnisse online aus.",
        "name": "Arbeitsblatt",
        "useCasesHtml": "<ul> <li>Erstelle <strong>digitale Arbeitsblätter</strong>, Formulare, Wissensabfragen, Quizze und Lernstandserhebungen</li> <li>Integriere Multiple Choice Aufgaben, Lückentexte, Hinweise und freie Arbeitsaufträge mit wenigen Klicks</li> <li>Sammle die <strong>Ergebnisse digital</strong> ein und werte sie einfach und übersichtlich online aus</li> <li>Erfasse Unterrichtsfeedback digital und anonym und werte es online aus</li> <li>Frage (Vor-)Wissen, Meinungen und Selbsteinschätzungen von Schüler*innen ab</li> <li>Drucke die Vorlagen alternativ aus und <strong>nutze sie analog</strong></li> </ul>",
        "videos": [
          {
            "id": "1099612801"
          }
        ]
      },
      "worksheet_wizard": {
        "description": "Erstelle Arbeitsblätter mit KI-generierten Aufgaben, teile und werte sie digital aus",
        "name": "Arbeitsblatt generieren"
      }
    }
  }
}
